import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Legacy external-feed link /jobs/apply/<job_link>/ (external_integration feed,
 * <job_link> = Job.job_link slug). Replaces itself with the public job page and
 * keeps the query string, so utm_* / r tags are captured by CheckAuthAndRedirect.
 */
const JobApplyRedirect = () => {
  const { link } = useParams();
  const { search, hash } = useLocation();
  const slug = (link || "").trim();
  if (!slug) return <Navigate to={{ pathname: "/jobs", search }} replace />;
  return <Navigate to={{ pathname: `/jobs/${encodeURIComponent(slug)}`, search, hash }} replace />;
};

export default JobApplyRedirect;
